import React from "react";
const SvgPoiSchoolNursery = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#0981F9"
        d="M24 12c0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12S5.372 0 12 0c6.627 0 12 5.373 12 12"
      />
      <path
        fill="#FFF"
        d="M10.475 16.66a2.31 2.31 0 012.277-1.777c1 0 1.879.645 2.212 1.571a21.992 21.992 0 01-3.28.248c-.404 0-.806-.02-1.209-.042m9.748-1.178a.468.468 0 00-.603-.264c-.752.293-1.518.538-2.293.744l-1.074-4.435c.079.003.81.04 1.164.827a.467.467 0 00.852-.382c-.621-1.38-1.966-1.373-2.036-1.377h-.71l-.01.001H12.49V8.014c0-1.503-1.596-1.973-2.457-2.014H8.254a.334.334 0 00-.334.355l.09 1.286-1.97 2.017a.334.334 0 00.002.47l1.481 1.482a.344.344 0 00.472 0c.645-.645.98-.667 1.091-.648.061.01.106.042.134.073L8 16.268a.34.34 0 00-.003.111 21.62 21.62 0 01-2.4-.536.468.468 0 00-.259.897c2.055.594 4.19.895 6.347.895 2.855 0 5.639-.52 8.275-1.548a.465.465 0 00.264-.605"
      />
    </g>
  </svg>
);
export default SvgPoiSchoolNursery;
